/* eslint-disable @typescript-eslint/no-invalid-void-type */
import { apiSlice } from './apiSlice';
import Vehicle from '../../core/models/Vehicle';
import Auction from '../../core/models/Auction';
import AuctionItem from '../../core/models/AuctionItem';
import LiveAuctionStatus from '../../core/models/LiveAuctionStatus';
import InitialAuctionStatus from '../../core/models/InitialAuctionStatus';

export const auctionApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getActiveAuction: builder.query<Auction, void>({
            query: () => '/auctions/active',
            keepUnusedDataFor: 0,
            providesTags: (result, error, id) => [{ type: 'Auction', id: 'live' }],
        }),
        getPastAuctions: builder.query<Vehicle[], void>({
            query: () => '/auctions/closed',
            keepUnusedDataFor: 5,
            providesTags: (result, error, arg) =>
                result
                    ? [...result.map(({ id }) => ({ type: 'Auction' as const, id })), { type: 'Auction', id: 'LIST' }]
                    : [{ type: 'Auction', id: 'LIST' }],
        }),
        getAuctionById: builder.mutation<Auction, string>({
            query: (auctionId) => `/auctions/${auctionId}`,
        }),
        getAuctionItemById: builder.query<AuctionItem, string>({
            query: (auctionItemId) => `/auctions/auctionItem/${auctionItemId}`,
            providesTags: (result, error, id) => [{ type: 'AuctionItem' }],
        }),
        getLiveAuctionStatus: builder.query<InitialAuctionStatus, string>({
            query: (auctionId) => `/auctions/inProgressAuctionStatus/${auctionId}`,
            keepUnusedDataFor: 0,
            providesTags: (result, error, id) => [{ type: 'AuctionStatus', id: 'live' }],
        }),
        // getLiveAuctionStatus: builder.mutation<LiveAuctionStatus, string>({
        //     query: (auctionId) => `/auctions/inProgressAuctionStatus/${auctionId}`,
        // }),
    }),
});

export const {
    useGetActiveAuctionQuery,
    useGetPastAuctionsQuery,
    useGetAuctionItemByIdQuery,
    useGetAuctionByIdMutation,
    useGetLiveAuctionStatusQuery,
} = auctionApiSlice;